import WebServiceRequest from './WebServiceRequest'

export async function tagRequest(context, action, data = {}) {
  const request = new WebServiceRequest(context)
  request.setTag(`Tag/${action}`)
  if (action === 'Delete') request.setRequestParam({ tagId: data.tagId })
  else request.setRequestParamDataObj(data)

  let result
  let failure
  try {
    await request.fetch(content => { result = content }, error => { failure = error })
  } catch (error) {
    throw new Error('ارتباط با سرور برقرار نشد. دوباره تلاش کنید.')
  }
  if (failure || result === undefined) {
    throw new Error((failure && failure.errorMessage) || 'دریافت یا ذخیره تگ‌ها انجام نشد. دوباره تلاش کنید.')
  }
  return result
}
